import * as React from 'react';
import Card from './Card';
import '../css/gift-card.sass';

interface GiftCardProps {
  id: string;
  value?: string;
  last4digits?: string;
  validThruLabel?: string;
  validityDate?: string;
  vendor: string;
  promotionalLabel?: string;
  deliveryStatusMsg?: React.ReactNode;
  activationStatusMsg?: string;
  activationStatusColor?: 'green' | 'yellow' | 'red' | 'gray';
}

export default function GiftCard(props: GiftCardProps) {
  const { validThruLabel = 'Valid Thru: ', promotionalLabel = 'Promotional' } =
    props;
  const maskedCardNumber =
    props.vendor.toLowerCase() === 'tango'
      ? 'xxxx xxxx xxxx xxxx'
      : 'xxxx xxxx xxxx';
  return (
    <>
      <div className="gift-card" id={props.id}>
        {props.vendor.toLowerCase() === 'tango' ? (
          <div className="card-title-tango">
            <img
              alt="Tango-Dish-Promo"
              src="/cms-files/giftcard/prepaid_mastercard.png"
              className="card-content"
            />
            {props.value && (
              <div className="card-amount-tango">
                <span className="sr-only">Initial value:</span>{' '}
                {/* visually-hidden content  to support screenReaders */}
                <span>{props.value}</span>
              </div>
            )}
          </div>
        ) : (
          <Card>
            <div className="card-title">
              <img alt="" className="dish-logo" />
              {props.value && (
                <div className="amount">
                  <span className="sr-only">Initial value:</span>{' '}
                  {/* visually-hidden content  to support screenReaders */}
                  <span className="dollar">$</span>
                  <span className="value">{props.value}</span>
                </div>
              )}
            </div>
            <div className="card-number">
              <span className="maskedCard">{maskedCardNumber}</span>
              {props.vendor.toLowerCase() !== 'tango' && (
                <span>{props.last4digits}</span>
              )}
            </div>
            <div className="validity">
              {props.vendor.toLowerCase() !== 'tango' && (
                <span>
                  <span>{validThruLabel}</span>
                  <span>{props.validityDate}</span>
                </span>
              )}
              <span className="promotional">{promotionalLabel}</span>
            </div>
          </Card>
        )}

        {props.activationStatusMsg && (
          <div className="card-status">
            <span>{props.activationStatusMsg}</span>
            <span className={`status-color ${props.activationStatusColor}`}>
              &nbsp;
            </span>
          </div>
        )}
        {props.deliveryStatusMsg && (
          <div className="card-delivery-status">{props.deliveryStatusMsg}</div>
        )}
      </div>
    </>
  );
}
